import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileDateInputControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        let child = element.find("div:first");
        child.css({"width":"100%", "height":"", "display": "flex"});
        child.find("div:first").css({"height":"100%", "display":"inline-flex", "align-items":"center", "justify-content":"left"});
    }
}

const mobileDateInputControlView = new MobileDateInputControlView();
export default mobileDateInputControlView;